import AlertContainer from "../../../Components/UiKits/Alert/AlertContainer";

const Alert = () => {
  return <AlertContainer />;
};

export default Alert;
